<template>
  <div class="community_select">
    <h5 v-if="selectedMetricCategory == null">{{ "Select a metric above to display communities" }}</h5>
    <div v-else style="height: inherit">
      <div class="selection_mode_options">
        <h5 style="display: inline-block; margin-left: 1rem;">{{ selectionBoxMode }}</h5>
        <select-box-dropdown style="display: inline-block; margin-top: 1rem; margin-right: .5rem;" class="right"></select-box-dropdown>
      </div>
      <div class="selection_listing">
        <community-list v-if="selectionBoxMode === 'Communities'"></community-list>
        <aeaenergyregion-list v-if="selectionBoxMode === 'AEA Energy Regions'"></aeaenergyregion-list>
        <census-area-list v-if="selectionBoxMode === 'Census Areas'"></census-area-list>
      </div>
      <div class="selection_footer">
        <input style="vertical-align: bottom;" v-model="filterBoxText" @input="updateFilter" placeholder="Search table..." />
      </div>
    </div>
  </div>
</template>
<script>
import CommunityList from './CommunityList.vue'
import CensusAreaList from './CensusAreaList'
import AeaenergyregionList from './AEAEnergyRegionList'
import SelectBoxDropdown from './SelectBoxDropdown.vue'
import _ from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'community-select-box',
  data: function () {
    return {
      filterBoxText: ''
    }
  },
  computed: mapState([
    'selectionBoxMode',
    'selectedMetricCategory'
  ]),
  methods: {
    modeSelection: function (mode) {
      if (this.selectionBoxMode !== mode) {
        this.$store.commit({
          type: 'communitySelectionModeChange',
          mode: mode
        })
      }
    },
    updateFilter: _.debounce(function () {
      this.$store.commit({
        type: 'selectFilterText',
        value: this.filterBoxText.toLowerCase() // Lowercase for simple comparison
      })
    }, 300)
  },
  components: {
    AeaenergyregionList,
    CensusAreaList,
    CommunityList,
    SelectBoxDropdown
  }
}
</script>
<style>
  .community_select {
    height: 600px;
  }

  .selection_mode_options {
    height: 10%;
  }

  .selection_listing {
    box-sizing: border-box;
    height: 80%;
    width: 100%;
    overflow-y: scroll;
  }

  .selection_footer {
    margin-top: .5rem;
    height: 10%;
    border-top: 1px solid black;
  }

  .center_cell {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// CommunitySelectBox.vue?53515e5c